import qs from 'qs';

import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const passwordForget = payload => httpClient.post(apis.PASSWORD_FORGET, qs.stringify(payload), {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});